import {useUserContext} from '../contexts/UserContext'

// Thin reader of the single, shared company-logo probe that lives in
// UserContext (probed once per account_logo_url and reused everywhere). Returns:
//
//   { companyLogoUrl, isCompanyLogoLoading }
//
// `companyLogoUrl` is the proven-loadable URL, or null when there is no logo, the
// URL is invalid, or the probe failed — callers then fall back to the company
// name. `isCompanyLogoLoading` is true only while the probe for a safe URL is in
// flight, so one-shot actions (Copy Quote clipboard, PDF download/print) can wait
// for a final value instead of capturing the pending null. Every consumer shares
// this one result — no per-consumer probing.
export const useCompanyLogo = () => {
    const {companyLogoUrl, isCompanyLogoLoading} = useUserContext()
    return {companyLogoUrl, isCompanyLogoLoading}
}
